// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export const getEnvVariable = (name: string, backupValue = ''): string => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return window?.env?.[String(name)] ?? process.env?.[String(name)] ?? backupValue
  } catch (e) {
    return backupValue
  }
}